import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Button, Link, Modal, Paper, Slider, styled, Typography } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

import { loadStripe } from '@stripe/stripe-js';
import DashboardBackButtonComponent from './footer/DashboardBackButtonComponent';
import DashboardFAQComponent from './DashboardFAQComponent';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_qblFNYngBkEdjEZ16jxxoWSM');

const marks = [
    {
        value: 2,
        label: "£2"
    },
    {
        value: 5,
        label: "£5"
    },
    {
        value: 20,
        label: "£20"
    }
];

function DashboardMembership() {

    const options = {
        // passing the client secret obtained from the server
        clientSecret: 'pk_test_51NlHKq2MsJ2UXvaBTZGfefwQTqUkXOqltZju9OBTKbeoE9lFA4EqCXOO90Fd0L9bKBM9jhrfnyTfJ9owEWI4ZADs00XMYzFXiK',
    };

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        karmaContext.notificationManager.fetchNotifications();
    }, []);

    const [notifications, setNotifications] = useState("");

    useEffect(() => {
        if (karmaContext.local.notifications === undefined ||
            karmaContext.local.notifications[0] === undefined) {
            return;
        }

        setNotifications(karmaContext.local.notifications);

    }, [karmaContext.local.notifications]);

    if (karmaContext.local.user === undefined || !karmaContext.local.user.member) {
        return RenderDashboardPrimary();
    } else {
        return RenderDashboardAlreadyMember()
    }
}

function valuetext(value) {
    return `£${value}`;
}

const CustomSlider = styled(Slider)(({ theme }) => ({
    "& .MuiSlider-markLabel": {
        color: "whitesmoke"
    }
}));

function PaymentLinkButton(props) {

    const karmaContext = useKarmaPoolContext();

    function handleClick(event) {
        event.preventDefault();

        karmaContext.paymentManager.getPaymentLink(props.monthlyCost, (data) => {
            console.log("URL : " + data.url + "?client_reference_id=" + karmaContext.local.user.id);
            window.location.href = data.url + "?client_reference_id=" + karmaContext.local.user.id;

            // Open in new window
            //window.open(data.url + "?client_reference_id=" + karmaContext.local.user.id, '_blank');
        });
    }

    return (
        <Button variant="contained" color="info" onClick={handleClick} sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.325rem", marginBottom: "0.125rem" }}>
            Subscribe
        </Button>
    );
}

function RenderDashboardAlreadyMember() {

    const karmaContext = useKarmaPoolContext();

    const [monthlyCost, setMonthlyCost] = useState(2);

    function onSliderChange(event, value) {
        setMonthlyCost(value);
    }

    const [subscriptionDetails, setSubscriptionDetails] = useState(() => {
        return {
            loading: true,
            joinDateTime: "",
            renewalDateTime: "",
            memberSubscriptionAmount: 0,
            giftedMember: false
        }
    });

    useEffect(() => {
        if (karmaContext.local.subscriptionDetails === undefined) {
            return;
        }

        console.log("subscriptionDetails : " + JSON.stringify(karmaContext.local.subscriptionDetails));
        setSubscriptionDetails(karmaContext.local.subscriptionDetails);
    }, [karmaContext.local.subscriptionDetails]);

    useEffect(() => {
        karmaContext.subscriptionDetailsManager.updateSubscriptionDetails();
    }, []);

    const [stripePromise, setStripePromise] = useState(loadStripe("pk_test_51NlHKq2MsJ2UXvaBTZGfefwQTqUkXOqltZju9OBTKbeoE9lFA4EqCXOO90Fd0L9bKBM9jhrfnyTfJ9owEWI4ZADs00XMYzFXiK"));

    /* useEffect(() => {
       fetch("/config").then(async (r) => {
         const { publishableKey } = await r.json();
         setStripePromise(loadStripe(publishableKey));
       });
     }, []);*/

    const [open, setOpen] = useState(false);

    function cancelMembership() {
        karmaContext.paymentManager.cancelSubscription((obj) => {
            karmaContext.subscriptionDetailsManager.updateSubscriptionDetails();
            alert("take care <3 we will miss you");
            // refresh page
            window.location.reload();
        });
        setOpen(false);
    }

    function RenderSubscriptionAmount() {
        if (!karmaContext.local.user.membershipCancelled) {
            return (
                <>
                    <Paper sx={{ marginBottom: "1.0rem" }} />
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <Paper sx={{ marginBottom: "0.5rem" }} />
                        <Box sx={{
                            width: "47.5%", maxWidth: "18rem",
                            minWidth: "18rem", padding: "0.0rem",
                        }}>
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                You are contributing <strong>£{subscriptionDetails.memberSubscriptionAmount}
                                </strong> per month.
                            </Typography>
                        </Box>
                    </Box>
                </>
    
            );
        } else {
            return (
                <>
                    <Paper sx={{ marginBottom: "1.0rem" }} />
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <Paper sx={{ marginBottom: "0.5rem" }} />
                        <Box sx={{
                            width: "47.5%", maxWidth: "18rem",
                            minWidth: "18rem", padding: "0.0rem",
                        }}>
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                Your membership will last until
                                <br />
                                 <strong>{subscriptionDetails.renewalDateTime}</strong>.
                            </Typography>
                        </Box>
                    </Box>
                </>
    
            );
        }
    }

    function RenderCancelButton() {
        
    }

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    homeEnabled={true} />
            </Box>

            <Modal open={open} onClose={() => { setOpen(false) }}>
                <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.7)" }}>
                    <Box sx={{
                        width: "16rem", height: "8rem",
                        backgroundColor: "rgba(221, 221, 221, 0.075)",
                        borderRadius: "0.25rem",
                        borderColor: "rgba(221, 221, 221, 0.25)",
                        border: "1px solid rgba(221, 221, 221, 0.35)",
                    }} >
                        <Typography variant="body2" sx={{ color: "whitesmoke", padding: "1.0rem", textAlign: "center", marginTop: "0.25rem" }}>
                            Are you sure you want to cancel?
                        </Typography>

                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button
                                variant="contained"
                                color="info"
                                onClick={() => { cancelMembership() }}
                                sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.325rem", marginBottom: "0.125rem", marginRight: "0.25rem" }}>
                                Yes
                            </Button>
                            <Button
                                variant="contained"
                                color="info"
                                onClick={() => { setOpen(false) }}
                                sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.325rem", marginBottom: "0.125rem", marginLeft: "0.25rem" }}
                            >
                                No
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Box className={karmaStyles.homepageBox3}>
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", marginBottom: "0.25rem" }}>
                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                        {subscriptionDetails.loading ? "Loading..." :
                            <>
                                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>

                                    <Paper sx={{ marginBottom: "0.5rem" }} />
                                    <Box sx={{
                                        width: "47.5%", maxWidth: "18rem",
                                        minWidth: "18rem", padding: "0.0rem",
                                    }}>
                                        <Box sx={{ marginTop: "0.0rem" }}>
                                            <strong>Your Membership</strong>
                                            {/* on click, button should open /karma/dashboard/newsletter */}
                                            <Paper sx={{ marginBottom: "1.25rem" }} />
                                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                                {subscriptionDetails.giftedMember ? <>
                                                    You are a gifted member.
                                                </> :
                                                    <>
                                                        Joined: {subscriptionDetails.joinDateTime}
                                                        <br />
                                                        Renewal: {karmaContext.local.user.membershipCancelled ? "cancelled" : subscriptionDetails.renewalDateTime}
                                                    </>}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {subscriptionDetails.giftedMember ? null : <>
                                    {RenderSubscriptionAmount()}
                                </>
                                }
                            </>}
                        {subscriptionDetails.giftedMember || karmaContext.local.user.membershipCancelled ?
                            null
                            :
                            <>
                                <Paper sx={{ marginTop: "1.25rem" }} />
                                <Box sx={{ width: "100%", minWidth: "14rem", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>

                                    <Button variant="contained" color="info" onClick={() => { setOpen(true) }} sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.325rem", marginBottom: "0.125rem" }}>
                                        Cancel
                                    </Button>
                                </Box>
                            </>
                        }
                        <Paper sx={{ marginBottom: "2.5rem" }} />
                        <DashboardBackButtonComponent />

                    </Typography>
                </Box>
            </Box>

            <Paper sx={{ marginBottom: "2.45rem" }} />
        </>
    );
}

function RenderDashboardPrimary() {

    const karmaContext = useKarmaPoolContext();

    const [monthlyCost, setMonthlyCost] = useState(2);

    function onSliderChange(event, value) {
        setMonthlyCost(value);
    }

    const [stripePromise, setStripePromise] = useState(loadStripe("pk_test_51NlHKq2MsJ2UXvaBTZGfefwQTqUkXOqltZju9OBTKbeoE9lFA4EqCXOO90Fd0L9bKBM9jhrfnyTfJ9owEWI4ZADs00XMYzFXiK"));

    /* useEffect(() => {
       fetch("/config").then(async (r) => {
         const { publishableKey } = await r.json();
         setStripePromise(loadStripe(publishableKey));
       });
     }, []);*/

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    homeEnabled={true}
                    nonMember={false} />
            </Box>

            <Box className={karmaStyles.homepageBox3}>
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", marginBottom: "0.25rem" }}>
                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", padding: "0.0rem",
                            }}>
                                <Box sx={{ marginTop: "0.0rem" }}>
                                    <strong>Become a member</strong>
                                    {/* on click, button should open /karma/dashboard/newsletter */}
                                    <Paper sx={{ marginBottom: "0.25rem" }} />
                                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                        Gain a democratic share in how the Karma Pool donates. Get full access, including note creation, a newsletter & discounts to future events.
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "2.0rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", padding: "0.0rem",
                            }}>
                                <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                    £{monthlyCost} per month.
                                </Typography>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "0.75rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", padding: "0.0rem",
                            }}>
                                <CustomSlider
                                    aria-label="Donation amount"
                                    defaultValue={2}
                                    getAriaValueText={valuetext}
                                    valueLabelDisplay="auto"
                                    step={1}
                                    size="large"
                                    marks={marks}
                                    onChange={onSliderChange}
                                    min={1}
                                    max={20}
                                    sx={{ width: "80%" }}
                                />
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }} id="faq_start1" >
                            <Box sx={{
                                backgroundColor: "rgba(221, 221, 221, 0.05)",
                                borderRadius: "0.25rem",
                                borderColor: "rgba(221, 221, 221, 0.25)",
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", paddingTop: "1.0rem",
                                paddingBottom: "1.0rem",
                                border: "1px solid rgba(221, 221, 221, 0.35)",
                            }}>
                                £{Math.max(monthlyCost - 1, 0)} goes directly to <Link href="/karma/dashboard/membership#faq_start1" pointer={true} style={{ textDecoration: 'none' }}>
                                    <strong>Karma Pool</strong></Link>
                                <br />for giving to good causes.
                                <br />
                                <br />
                                £1 goes to cover fees & <Link href="/karma/dashboard/membership#faq_start2" pointer={true} id="faq_start2" style={{ textDecoration: 'none' }}>
                                    <strong>Karmatic</strong> </Link>
                                <br />for growth & development.
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>
                            <Box sx={{
                                background: "rgba(0, 0, 0, 0.3)",
                                borderRadius: "8px",
                                boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                                color: "white",
                                padding: "10px 20px",
                                textAlign: "center",
                                maxWidth: "18rem",
                                minWidth: "14rem",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "3rem"
                            }}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    you get 20 tokens every cycle
                                </Typography>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "0.75rem" }} />
                        <Box sx={{ width: "100%", minWidth: "14rem", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>
                            <PaymentLinkButton monthlyCost={monthlyCost} />
                        </Box>
                        <Paper sx={{ marginBottom: "2.0rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "18rem", padding: "0.0rem",
                            }}>
                                <Box sx={{ marginTop: "0.0rem" }}>
                                    <strong>Boost your charitable impact 🌱</strong>
                                </Box>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <DashboardFAQComponent donationAmount={monthlyCost - 1} />
                        <Paper sx={{ marginBottom: "1.5rem" }} />

                        {/* Imagine a platform with an advanced advertising system, where 100% of the revenue went to good causes.
                        It is an explicit aim. We are often told our data is our most valuable commodity. Yet we give it
                        up for free to the corporations. What if we take control, and use the value of our attention to make the world a better place?


                        One that will eventually be used by millions of people to give billions of pounds to good causes.
                                        Failure to reach such lofty ambitions is just charity with extra steps. I'll happily give it all away if it means I can make a difference. */}
                        <Paper sx={{ marginBottom: "2.5rem" }} />
                        <DashboardBackButtonComponent />

                    </Typography>
                </Box>
            </Box>

            <Paper sx={{ marginBottom: "2.45rem" }} />
        </>
    );
}

export default DashboardMembership;
